import { isPC } from '@/utils'
import { isHKSite } from '@/utils/util'
const isHK = isHKSite()
if (!isPC() && !isHK) {
  /** 移动端访问香港官网不重定向到移动端官网，继续访问pc官网 */
  window.location.href = 'https://m.shangminet.com/'
}
